<template>
  <f7-list-item
      :link="'/training-sessions/' + training_session.id + '/'"
      :title="training_session.name"
      :after="training_session.weekday"
      :subtitle="training_session.start_date_day_full"
      swipeout
      @swipeout:deleted="onDeleted"
  >
    <template v-slot:media>
      <f7-icon f7="bolt_fill"></f7-icon>
    </template>
    <f7-swipeout-actions left>
      <f7-swipeout-button color="blue" @click="onCopy" :close="true">Kopieer</f7-swipeout-button>
    </f7-swipeout-actions>
    <f7-swipeout-actions right>
      <f7-swipeout-button delete confirm-text="Are you sure you want to delete this item?">
        Delete
      </f7-swipeout-button>
    </f7-swipeout-actions>
  </f7-list-item>
</template>

<script>

export default {
  components: {},

  props: ['training_session'],

  mixins: [],

  data: function () {
    return {
      //
    };
  },

  computed: {
    user_id() {
      return this.$store.state.current_user.data.id;
    },
  },

  created() {
    //
  },

  mounted() {
    //
  },

  methods: {
    onDeleted() {
      this.$store.dispatch('training_sessions/destroy', {
        user_id: this.user_id,
        training_session_id: this.training_session.id,
      });
    },
    onCopy(event) {
      this.$store.dispatch('training_sessions/copy', {
        user_id: this.user_id,
        training_session_id: this.training_session.id
      });
    }
  },

  watch: {
    //
  }
};
</script>
